import React from 'react'
import { compose, withPropsOnChange } from 'recompose'
import EquipmentWidget from '@infotech/equipment-widget'
import { Modal, modalEnhancer } from '@infotech/base-components'
import { PrimaryButton } from '@infotech/uikit-button'

import './equipment-field.scss'
import equipmentWidgetAdapter from './equipmentWidgetAdapter'
import equipmentWidgetDependencies from './equipmentWidgetDependencies'


const ToggleComponent = ({ onToggle }) => (
  <PrimaryButton
    onClick={onToggle}
    type="button"
  >
    Добавить оборудование
  </PrimaryButton>
)

const HeaderComponent = () => `Добавить оборудование`

const WrapperComponent = ({ children }) => (
  <div className="ej-equipment-field-widget">
    { children }
  </div>
)

const EquipmentWidgetModalComponent = ({
  isOpen, onToggle, input, dependencies,
}) => (
  <Modal
    toggleComponent={ToggleComponent}
    headerComponent={HeaderComponent}
    wrapperComponent={WrapperComponent}
    isOpen={isOpen}
    onToggle={onToggle}
    modalClassName="ej-equipment-field-widget-modal"
  >
    <EquipmentWidget
      dependencies={dependencies}
      input={input}
      onToggleWidget={onToggle}
    />
  </Modal>
)

const EquipmentWidgetModal = compose(
  modalEnhancer,
  equipmentWidgetAdapter,
  withPropsOnChange([`onToggle`], ({ onToggle }) => ({
    dependencies: {
      ...equipmentWidgetDependencies,
      onToggleWidget: onToggle,
    }
  })),
)(EquipmentWidgetModalComponent)

export default EquipmentWidgetModal
